export class DCOption {
  name: string;
  num: string;

  constructor(name: string, num: string) {
    this.name = name;
    this.num = num;
  }

  getLabel(): string {
    return `${this.name} (${this.num})`;
  }
}

// Export the list of DCs
export const DC_OPTIONS: DCOption[] = [
  new DCOption("WIRV", "WIRV"),
  new DCOption("WSLC", "WSLC"),
  new DCOption("WPOA", "WPOA"),
  new DCOption("WMET", "WMET"),
  new DCOption("WLAN", "WLAN"),
  new DCOption("WWEL", "WWEL"),
  new DCOption("WPON", "WPON"),
  new DCOption("WSPK", "WSPK"),
  new DCOption("WANC", "WANC"),
  new DCOption("WAUB", "WAUB"),
  new DCOption("WBRE", "WBRE"),
  new DCOption("WLAS", "WLAS"),
  new DCOption("WDEN", "WDEN"),
  new DCOption("WLLA", "WLLA"),
  new DCOption("WNCA", "WNCA"),
  new DCOption("WHAW", "WHAW"),
  new DCOption("WSUN", "WSUN"),
  new DCOption("WPHA", "WPHA"),
  new DCOption("WDAL", "WDAL"),
  new DCOption("WMEL", "WMEL")
];
export const ALL_DCS: string[] = DC_OPTIONS.map((dc) => dc.name).sort((a, b) => a.localeCompare(b));
